export default __webpack_public_path__ + "static/media/circle-chatbot-conseiller.20bd122c.png";